module.exports = __webpack_public_path__ + "static/media/2.8e98837a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/2.svg
// module id = 132
// module chunks = 0